<ng-container [ngSwitch]="step">
  <db-ai-builder-create-page-options *ngSwitchCase="'options'"
                                     [websiteTenWebTheme] = "websiteTenWebTheme"
                                     [demoUser] = "demoUser"
                                     [tenWebTheme] = "tenWebTheme"
                                     [website]="website"
                                     [userSubscription]="userSubscription"
                                     [defaultThemes] = "defaultThemes"
                                     (onOptionChose)="changeStep($event)"></db-ai-builder-create-page-options>

  <db-ai-builder-create-page-builder *ngSwitchCase="'builder'"
                                     [websiteId]="website?.id"
                                     [hideBackButton]="hideBackButton"
                                     [demoUser]="demoUser"
                                     (showUpgradePopup)="showUpgradePopup($event)"
                                     (onBack)="changeStep('options')"
                                     (onRecreate)="recreate($event)">
  </db-ai-builder-create-page-builder>

  <db-ai-builder-create-page-templates *ngSwitchCase="'templates'"
                                       [demoUser]="demoUser"
                                       [selectedCategory]="templateCategory"
                                       [hideBackButton]="hideBackButton"
                                       (onRunAi)="importTenWebTemplate($event.selectedTemplate)"
                                       (onBack)="changeStep( $event.step, $event.templateScreenshot)"
                                       (showUpgradePopup)="showUpgradePopup($event)"
                                       (templateCategory)="addTemplateCategory($event)">
  </db-ai-builder-create-page-templates>

  <db-ai-builder-create-page-preview-demo *ngSwitchCase="'preview'"
                                          [hideBackButton]="hideBackButton"
                                          [templateScreenshot]="templateScreenshot"
                                          [selectedCategory]="templateCategory"
                                          (onBack)="changeStep($event.step, $event.templateScreenshot, $event.selectedCategory)">
  </db-ai-builder-create-page-preview-demo>

  <db-ai-builder-create-page-blank *ngSwitchCase="'blank'"
                                   (onBack)="changeStep('options')"
                                   [demoUser]="demoUser"
                                   (showUpgradePopup)="showUpgradePopup($event)"
                                   (onAddPage)="addPage($event)">
  </db-ai-builder-create-page-blank>

  <db-create-ai-process *ngSwitchCase="'recreateBuilder'"
                        [step]="recreationStep"
                        [modalView]="true"></db-create-ai-process>

</ng-container>
